// extracted by mini-css-extract-plugin
export default {"authBtn":"AuthBtn_authBtn__6hdyv"};